import React from 'react';

import { Icon } from '@fhs-legacy/universal-components';

export const PrepaidIcon = () => <Icon variant="plkGiftCard" />;
